<template>
  <div class="results">
    <div class="results-score-container">
      <div class="results-score">
        <h3>YOUR SCORE</h3>
        <p class="user-score">{{ this.$store.state.score }}</p>
      </div>
    </div>
    <h2>Is your score a reflection of safety in your store?</h2>
    <p>Reduce Injuries. Help teach, coach and empower associates to work safe each and every day.</p>
    <router-link to="/">
      <Button color="orange" buttonText="Exit" class="button"></Button>
    </router-link>
  </div>
</template>

<script>
import Button from '@/components/Button'

import RecordService from '@/services/RecordService'

export default {
  name: 'spotTheNotImage',
  components: {
    Button,
  },
  mounted() {
    this.$ga.page('/results')
    let score = this.$store.state.score
    let user = this.$store.state.user

    Object.keys(user).length !== 0
    if(Object.keys(user).length !== 0) {
      let payload = Object.assign({}, user)
      payload.score = score

      RecordService.putRecord(payload)
    }
  }
}
</script>

<style lang="scss" scoped>
.results {
  
  & &-score-container {
    background: url('../assets/score_background.png') center center no-repeat;
    height: 620px;
    margin: 0 auto 0;
    position: relative;
    width: 100%;

    .results-score {
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    .user-score {
      font-size: 130px;
      font-weight: 200;
      letter-spacing: -3px;
      line-height: 160px;
      margin: 0;
      text-shadow: 6.364px 6.364px 89.24px rgba(0, 0, 0, 0.3);
    }
  }

  h2 {
    color: #fff;
    font-size: 42px;
    margin-top: -50px;
  }

  h3 {
    color: #fff;
    margin:-10px 0 0 0;
    font-size:24px;
    font-weight: normal;
  }

  p {
    color: #fff;
    font-size: 35px;
    text-align: center;
    padding: 0 200px;
  }
}
</style>
